<template>
	<div class="program-list">
		<div class="page-container">
			<PageTitle ch="駐村藝術家列表" en="Artists"></PageTitle>
			<ul class="filter">
				<li class="f-item" :class="{active: filter=='all'}" @click="yearFilter('all')">全部</li>
				<template v-for="year in filterOptions">
					<li class="f-item" :class="{active: filter==year}" @click="yearFilter(year)" :key="year">{{year}}</li>
				</template>
			</ul>

			<div class="artist-center">
				<b-row class="artist flex-wrap">

					<b-col :key="index" class="center-box" v-for="(item, index) in artistResult" lg="3" md="6" sm="12">
						<router-link tag="div" :to="'/program/'+ item.id" class="a-item">
							<img :src="item.coverImg" alt="" class="a-bg">
							<div class="a-cover">
								<div class="name-ch">{{item.nameCh}}</div>
								<div class="name-en">{{item.nameEn}}</div>
								<div class="city">{{item.cityCh+" · "+item.city}}</div>
							</div>
						</router-link>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
import PageTitle from '@/components/page_title'
import ArtistData from '../../../static/assets/program/artistData.json'

export default {
	metaInfo: {
		title: '利澤國際偶戲藝術村'
	},
	name: 'programList',
	data() {
		return {
			ArtistData,
			currentArtist: "",
			isShowPop: false,
			filter: 'all',
			currentPop: {}
		}
	},
	methods: {
		yearFilter: function (year) {
			this.filter = year;
		},
	},
	computed: {
		artistResult: function () {
      console.log(this._);
			let result = this._.reverse(this._.sortBy(ArtistData, o => o.startTime))
			if (this.filter == 'all') {
				return result
			} else {
				return this._.filter(result, { 'stayYear': this.filter })
			}
		},
		filterOptions() {
			return ArtistData.reduce((a, { stayYear }) => a.includes(stayYear) ? a : a.concat(stayYear), new Array);
		}
	},
	components: {
		PageTitle
	}
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 768px){
	.filter{
		flex-wrap:wrap;
		.f-item{
			width: 50px !important;
			height: 50px !important;
			margin:5px !important;

		}
	}
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'
  .program-list
    position: relative
    .filter
      +flexLayout('center', 'row')
      .f-item
        +flexLayout('center', 'row')
        background-color: #01b6e2
        border-radius: 100px
        width: 161px
        height: 38px
        color: white
        margin: 0 20px 32px
        cursor: pointer
        opacity: 0.6
        &:hover
          opacity: 1
      .active
        opacity: 1
    .artist-center
      +flexLayout('center', 'row')
      width: 100%
      .center-box
        +flexLayout('center', 'row')
      .artist
        max-width: 1280px
        margin: 0 auto
        margin-bottom: 80px
        width: 100%
        .a-item
          position: relative
          height: 275px
          width: 275px
          background-size: cover
          background-position: 50% 50%
          align-self: start
          margin: 35px 10px 0px 10px
          cursor: pointer
          .a-bg
            height: 100%
            width: 100%
            position: absolute
            top: 50%
            left: 50%
            transform: translateX(-50%) translateY(-50%)
            z-index: -1
            object-fit: cover;
          .a-cover
            position: absolute
            bottom: 0
            left: 0
            color: white
            font-size: $font-size-3
            line-height: 1.5
            font-weight: 200
            padding: 10px
            width: 100%
            background-color: rgba(black, 0.5)
          &:hover
            .a-bg
              filter: brightness(0.5) blur(1px)


</style>



// WEBPACK FOOTER //
// src/pages/program/program_list.vue